var YBRequest = require('../../../request')
var Parser = require('./parser')
var TransportFormat = require('../../../../constants/transportFormat')
const { AnalyticsTag } = require('../../../../../common/Constants');
const { default: Log } = require('../../../../../common/log');

var DashParser = Parser.extend(
  /** @lends npaw.DashParser.prototype */
  {
    /**
     * Starts the Dash parsing from the given resource. The first (outside) call should set the
     * parentResource to null.
     *
     * @param {string} resource The resource url.
     */
    parse: function (resource, lastManifest) {
      if (!lastManifest) {
        var request = new YBRequest(resource, null, null, { cache: true, requestHeaders: this._headers })

        request.on(YBRequest.Event.SUCCESS, function (resp) {
          this.parseLocation(resp, resource)
        }.bind(this))

        request.on(YBRequest.Event.ERROR, function (resp) {
          this.done()
        }.bind(this))

        request.send()
      } else {
        this.parseLocation(lastManifest, resource)
      }
    },

    parseLocation: function (lastManifest, resource) {
      this.iterations--
      var locationRegexp = new RegExp(/<Location>([\s\S]+)<\/Location>/)
      try {
        this._lastManifest = lastManifest
        var manifest = lastManifest.getResponseText()
        var matches = locationRegexp.exec(manifest)

        if (matches && matches[1]) {
          var newRes = this._htmlDecode(matches[1].replace('\n', ''))
        }
        if (newRes && newRes !== resource && this.iterations > 0) {
          this.parse(newRes)
        } else {
          this.parseFinalResource(manifest, resource)
        }
      } catch (err) {
        Log.warn(AnalyticsTag, 'Dash parse failed')
        this.done()
      }
    },

    _htmlDecode: function (input) {
      if (typeof document !== 'undefined' && typeof document.createElement === 'function') {
        var e = document.createElement('textarea')
        e.innerHTML = input
        return e.childNodes && e.childNodes.length ? e.childNodes[0].nodeValue : input
      }
      return input
    },

    parseFinalResource: function (manifest, resource) {
      var baseUrlRegexp = new RegExp(/<BaseURL>[\r\n]*(.*?)[\r\n]*<\/BaseURL>/g)
      var segmentTemplateRegexp = new RegExp(/<SegmentTemplate[\s\S]*?media="([^"]+)"/g)
      var segmentUrlRegexp = new RegExp(/<SegmentURL[\s\S]*?media="([^"]+)"/g)
      var matches = null

      try {
        if (this._parseLastChunk) {
          // Find all matches and take the last one
          var allMatches = []
          var match

          // Check BaseURL elements
          while ((match = baseUrlRegexp.exec(manifest)) !== null) {
            if (match[1] && this._isFullUrl(match[1])) {
              allMatches.push(match)
            }
          }

          // If no BaseURL found, check SegmentTemplate
          if (allMatches.length === 0) {
            while ((match = segmentTemplateRegexp.exec(manifest)) !== null) {
              if (match[1]) {
                allMatches.push(match)
              }
            }
          }

          // If no SegmentTemplate found, check SegmentURL
          if (allMatches.length === 0) {
            while ((match = segmentUrlRegexp.exec(manifest)) !== null) {
              if (match[1]) {
                allMatches.push(match)
              }
            }
          }

          // Use the last match if available
          if (allMatches.length > 0) {
            matches = allMatches[allMatches.length - 1]
          }
        } else {
          // Original behavior - get first match
          var baseUrlMatch = /<BaseURL>[\r\n]*(.*?)[\r\n]*<\/BaseURL>/.exec(manifest)
          var segmentTemplateMatch = /<SegmentTemplate[\s\S]*media="([^"]+)/.exec(manifest)
          var segmentUrlMatch = /<SegmentURL[\s\S]*media="([^"]+)/.exec(manifest)
          matches = baseUrlMatch || segmentTemplateMatch || segmentUrlMatch
        }

        this._getManifestMetadata(manifest)
        if (matches && matches[1] && this._isFullUrl(matches[1])) {
          if (matches[1].indexOf('"') > 0) {
            this._realResource = matches[1].substr(0, matches[1].indexOf('"')).replace('\n', '')
          } else {
            this._realResource = matches[1].replace('\n', '')
          }
        } else {
          this._realResource = resource
        }
      } catch (err) {
        Log.warn(AnalyticsTag, 'Dash manifest parse failed')
      }
      this.done()
    },

    _getManifestMetadata: function (manifest) {
      try {
        var transportFormatRegexp = new RegExp(/<AdaptationSet[\s\S]*mimeType="video\/([^"]+)/)
        var matches = transportFormatRegexp.exec(manifest)
        var ret = null
        switch (matches[1]) {
          case 'mp4':
          case 'm4s':
            ret = TransportFormat.MP4
            break
          case 'mp2t':
            ret = TransportFormat.MPEG2
            break
          case 'cmfv':
            ret = TransportFormat.CMF
            break
        }
        this._transportFormat = ret
      } catch (err) {
        Log.warn(AnalyticsTag, 'Couldnt find the transport format')
      }
    },

    _isFullUrl: function (url) {
      return url.indexOf('http') !== -1
    },

    shouldExecute: function (lastManifest) {
      var ret = true
      if (lastManifest) {
        var response = lastManifest.getResponseText()
        ret = response.indexOf('<MPD') !== -1
      }
      return ret
    }
  }
)

module.exports = DashParser
